module.exports = __webpack_public_path__ + "static/media/campaign-icon.bc95f629.png";